module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newOrder"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes,
      "activeRoute": _vm.activeRoute
    }
  }), _vm._v(" "), (_vm.dataPackage) ? _c('div', [_c('div', {
    staticClass: "orden-subtitulo text-title"
  }, [_c('h1', [_vm._v("Paquete " + _vm._s(_vm.dataPackage.attributes.package_name))]), _vm._v(" "), _c('div', {
    staticClass: "rr"
  }, [_c('a', {
    staticClass: "btn btn-clean btn-clean-white",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.backPage
    }
  }, [_c('i', {
    staticClass: "fas fa-long-arrow-alt-left"
  }), _vm._v("\n          Volver\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-tab"
  }, [_c('div', {
    staticClass: "detalle-inci"
  }, [_c('span', [_vm._v("Información del paquete")]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(" " + _vm._s(_vm.dataPackage.attributes.partial_weight))])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.dataPackage.attributes.items_from_order))])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.dataPackage.attributes.items_from_reposition))]), _vm._v(" "), (_vm.dataPackage.attributes.items_from_reposition > 0) ? _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showRepositionItemsDetail
    }
  }, [_vm._v("\n              Ver detalles\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.dataPackage.attributes.number_of_items))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detalle-inci"
  }, [(_vm.dataPackage.attributes.evaluated == 1) ? _c('div', [_c('span', [_vm._v("Detalle de evaluación de paquete")]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.dataPackage.attributes.real_number_of_items))])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.dataPackage.attributes.number_of_items_correct))])])]), _vm._v(" "), (_vm.dataPackage.attributes.incidents.length > 0) ? _c('div', {
    staticClass: "si-incidencias-container"
  }, [_c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo mensaje-inci si-incidencias"
  }, [_c('h1', [_c('i', {
    staticClass: "fas fa-times"
  }), _vm._v("Se generaron "), _c('span', [_vm._v(_vm._s(_vm.dataPackage.attributes.incidents.length))]), _vm._v(" incidencias")])])]), _vm._v(" "), _vm._l((_vm.dataPackage.attributes.incidents), function(incident) {
    return _c('div', {}, [(incident.attributes.clusterable_type == 'different_quantity') ? _c('div', {
      staticClass: "inci-container"
    }, [_c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v("Descripción: ")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(incident.attributes.description))])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v("Tipo: ")]), _vm._v(" "), (incident.attributes.clusterable.attributes.delta_type == 1) ? _c('h1', [_vm._v(" Déficit")]) : (incident.attributes.clusterable.attributes.delta_type == 2) ? _c('h1', [_vm._v("Exceso")]) : _c('h1', [_vm._v(" No definido")])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v("Items correctos sobre totales en el paquete: ")]), _vm._v(" "), _c('h1', [_vm._v(" " + _vm._s(incident.attributes.clusterable.attributes.correct_items + "/" + incident.attributes.clusterable.attributes.total_items))])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v(" " + _vm._s(incident.attributes.clusterable.attributes.delta_type == 1 ? 'Ejemplares a reponer:' : 'Ejemplares en exceso') + " ")]), _vm._v(" "), (incident.attributes.clusterable.attributes.delta_type == 1) ? _c('div', [_c('h1', [_vm._v(" " + _vm._s(_vm.deficitItems))]), _vm._v(" "), (incident.attributes.clusterable.attributes.delta_type == 1) ? _c('button', {
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showDeficitIncidentItemsDetail(incident.id)
        }
      }
    }, [_vm._v("\n                        Ver detalles\n                      ")]) : _vm._e()]) : _c('div', [_c('p', [_vm._v(" " + _vm._s((parseInt(incident.attributes.clusterable.attributes.total_items) - parseInt(incident.attributes.clusterable.attributes.correct_items)) * (-1)))])])])]) : _vm._e(), _vm._v(" "), (incident.attributes.clusterable_type == 'waste') ? _c('div', {
      staticClass: "inci-container"
    }, [_c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v("Descripción: ")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(incident.attributes.description))])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v("Tipo: ")]), _vm._v(" "), (incident.attributes.clusterable.attributes.correct_product_flag == 1) ? _c('h1', [_vm._v(" De merma del producto correcto")]) : _c('h1', [_vm._v(" De merma del producto equivocado")])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v("Ejemplares:")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(incident.attributes.clusterable.attributes.wasted_items) + " ")])])]) : _vm._e(), _vm._v(" "), (incident.attributes.clusterable_type == 'wrong') ? _c('div', {
      staticClass: "inci-container"
    }, [_c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v("Descripción: ")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(incident.attributes.description))])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v("Tipo: ")]), _vm._v(" "), (incident.attributes.clusterable.attributes.wasted_flag == 0) ? _c('h1', [_vm._v(" De producto equivocado sin merma")]) : _c('h1', [_vm._v(" De producto equivocado con merma")])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('h1', [_vm._v("Ejemplares: ")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(incident.attributes.clusterable.attributes.wrong_items))])])]) : _vm._e()])
  })], 2) : (_vm.dataPackage.attributes.incidents.length == 0) ? _c('div', [_vm._m(6)]) : _vm._e()]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "modalDetailItemsFail",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalDetailItemsFail"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Detalle de ejemplares del paquete actual repuestos en nuevos paquetes")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalDetailItemsFail
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_vm._l((_vm.deficitPackageRepositions), function(packageRepositionLevel) {
    return _c('div', [_c('hr', {
      staticStyle: {
        "height": "1px",
        "border": "none",
        "color": "#333",
        "background-color": "#333"
      }
    }), _vm._v(" "), _c('hr', {
      staticStyle: {
        "height": "1px",
        "border": "none",
        "color": "#333",
        "background-color": "#333"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('div', {
      staticClass: "resumen_titulo"
    }, [_c('h4', [_vm._v("REPUESTOS POR  " + _vm._s(_vm._f("cardinalityUpper")(packageRepositionLevel.level)) + " VEZ ")])])]), _vm._v(" "), (packageRepositionLevel.packageReposition.attributes.packages_info_free_by != null && packageRepositionLevel.packageReposition.attributes.packages_info_free_by.length > 0) ? _c('div', _vm._l((packageRepositionLevel.packageReposition.attributes.packages_info_free_by), function(packageInfo) {
      return _c('div', [_c('hr'), _vm._v(" "), _c('div', {
        staticClass: "resumen_orden"
      }, [_c('div', {
        staticClass: "resumen_titulo"
      }, [_c('h1', [_vm._v("Paquete nuevo ")])]), _vm._v(" "), _c('div', {
        staticClass: "resumen_content"
      }, [_c('h1', [_c('router-link', {
        attrs: {
          "to": {
            name: 'show-package',
            params: {
              id: packageInfo.attributes.id
            }
          }
        }
      }, [_vm._v(_vm._s(packageInfo.attributes.package_name))])], 1)])]), _vm._v(" "), _c('div', {
        staticClass: "resumen_orden"
      }, [_c('div', {
        staticClass: "resumen_titulo"
      }, [_c('h1', [_vm._v("Ejemplares repuestos")])]), _vm._v(" "), _c('div', {
        staticClass: "resumen_content"
      }, [_c('h1', [_vm._v("\n                  " + _vm._s(packageInfo.attributes.free_detail.free_items))])])])])
    }), 0) : _c('div', [_c('p', [_vm._v("Aún no se han repuesto ejemplares")])]), _vm._v(" "), _c('hr', {
      staticStyle: {
        "height": "1px",
        "border": "none",
        "color": "#333",
        "background-color": "#333"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('div', {
      staticClass: "resumen_titulo"
    }, [_c('h4', [_vm._v("Ejemplares repuestos por " + _vm._s(_vm._f("cardinality")(packageRepositionLevel.level)) + " vez reemplazados")])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_content"
    }, [_c('h4', [_vm._v("\n                  " + _vm._s(packageRepositionLevel.items_replaced))])])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('div', {
      staticClass: "resumen_titulo"
    }, [_c('h4', [_vm._v("Ejemplares repuestos por " + _vm._s(_vm._f("cardinality")(packageRepositionLevel.level)) + " vez pendientes ")])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_content"
    }, [_c('h4', [_vm._v("\n                  " + _vm._s(packageRepositionLevel.packageReposition.attributes.pendient_items))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('div', {
      staticClass: "resumen_titulo"
    }, [_c('h4', [_vm._v("Subtotal ejemplares repuestos por " + _vm._s(_vm._f("cardinality")(packageRepositionLevel.level)) + " vez  ")])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_content"
    }, [_c('h4', [_vm._v("\n                  " + _vm._s(parseInt(packageRepositionLevel.packageReposition.attributes.pendient_items) + parseInt(packageRepositionLevel.items_replaced)))])])])])
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "border": "none",
      "color": "#333",
      "background-color": "#333"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "border": "none",
      "color": "#333",
      "background-color": "#333"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "border": "none",
      "color": "#333",
      "background-color": "#333"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h4', [_vm._v("Total ejemplares a reponer en nuevos paquetes  ")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h4', [_vm._v("\n                " + _vm._s(_vm.deficitItems))])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDetailItemsFail()
      }
    }
  }, [_vm._v("Cerrar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalDetailReposition",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalDetailReposition"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Detalle de ejemplares de otros paquetes repuestos en el paquete actual")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalDetailReposition
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_vm._l((_vm.packageRepositions), function(packageRepositionLevel) {
    return _c('div', [_c('hr', {
      staticStyle: {
        "height": "1px",
        "border": "none",
        "color": "#333",
        "background-color": "#333"
      }
    }), _vm._v(" "), _c('hr', {
      staticStyle: {
        "height": "1px",
        "border": "none",
        "color": "#333",
        "background-color": "#333"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('div', {
      staticClass: "resumen_titulo"
    }, [_c('h4', [_vm._v("REPUESTOS POR  " + _vm._s(_vm._f("cardinalityUpper")(packageRepositionLevel.level)) + " VEZ ")])])]), _vm._v(" "), _vm._l((packageRepositionLevel.packageRepositions), function(packageReposition) {
      return _c('div', [_c('hr'), _vm._v(" "), _c('div', {
        staticClass: "resumen_orden"
      }, [_c('div', {
        staticClass: "resumen_titulo"
      }, [_c('h1', [_vm._v("Paquete de origen ")])]), _vm._v(" "), _c('div', {
        staticClass: "resumen_content"
      }, [_c('h1', [_c('router-link', {
        attrs: {
          "to": {
            name: 'show-package',
            params: {
              id: packageReposition.attributes.package.id
            }
          }
        }
      }, [_vm._v(_vm._s(packageReposition.attributes.package.attributes.package_name))])], 1)])]), _vm._v(" "), _c('div', {
        staticClass: "resumen_orden"
      }, [_c('div', {
        staticClass: "resumen_titulo"
      }, [_c('h1', [_vm._v("Ejemplares repuestos")])]), _vm._v(" "), _c('div', {
        staticClass: "resumen_content"
      }, [_c('h1', [_vm._v("\n                  " + _vm._s(packageReposition.attributes.free_detail.free_items))])])])])
    }), _vm._v(" "), _c('hr', {
      staticStyle: {
        "height": "1px",
        "border": "none",
        "color": "#333",
        "background-color": "#333"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "resumen_orden"
    }, [_c('div', {
      staticClass: "resumen_titulo"
    }, [_c('h4', [_vm._v("Subtotal ejemplares repuestos por " + _vm._s(_vm._f("cardinality")(packageRepositionLevel.level)) + " vez ")])]), _vm._v(" "), _c('div', {
      staticClass: "resumen_content"
    }, [_c('h4', [_vm._v("\n                  " + _vm._s(packageRepositionLevel.subtotal))])])])], 2)
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "border": "none",
      "color": "#333",
      "background-color": "#333"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "border": "none",
      "color": "#333",
      "background-color": "#333"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "border": "none",
      "color": "#333",
      "background-color": "#333"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h4', [_vm._v("Total ejemplares de otros paquetes  ")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h4', [_vm._v("\n                " + _vm._s(_vm.dataPackage.attributes.items_from_reposition))])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDetailReposition()
      }
    }
  }, [_vm._v("cerrar")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Peso aproximado (lb):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Ejemplares originales:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Ejemplares de otros paquetes: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Ejemplares totales:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("N° items evaluados:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("N° items correctos:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo mensaje-inci no-incidencias"
  }, [_c('h1', [_c('i', {
    staticClass: "fas fa-check"
  }), _vm._v("No se generaron incidencias")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2934107e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/package-show-view.vue
// module id = 1861
// module chunks = 1